{
    "name": "@lehuygiang28/gemini-proxy-cli",
    "version": "0.0.1-rc.3",
    "description": "CLI tool for managing Gemini Proxy API keys and proxy keys",
    "main": "dist/index.js",
    "type": "module",
    "bin": {
        "gproxy": "./dist/index.js"
    },
    "files": [
        "dist"
    ],
    "scripts": {
        "build": "tsup",
        "dev": "tsup --watch",
        "start": "node dist/index.js",
        "clean": "rimraf dist",
        "test": "node dist/test-validation.js",
        "test:validation": "tsup src/test-validation.ts --format esm && node dist/test-validation.js",
        "test:batch": "tsup src/test-batch-operations.ts --format esm && node dist/test-batch-operations.js"
    },
    "keywords": [
        "cli",
        "gemini",
        "proxy",
        "api-keys",
        "supabase"
    ],
    "author": "Lê Huy Giang <lehuygiang28@gmail.com>",
    "maintainers": [
        "lehuygiang28"
    ],
    "repository": {
        "type": "git",
        "url": "git+https://github.com/lehuygiang28/gemini-proxy.git"
    },
    "homepage": "https://github.com/lehuygiang28/gemini-proxy",
    "license": "MIT",
    "dependencies": {
        "@lehuygiang28/gemini-proxy-db": "^0.0.1",
        "@inquirer/prompts": "^7.8.3",
        "@supabase/supabase-js": "^2.55.0",
        "commander": "^12.0.0",
        "dotenv": "^17.2.1",
        "ora": "^8.0.1",
        "uuid": "^10.0.0"
    },
    "devDependencies": {
        "@types/node": "^22.0.0",
        "@types/uuid": "^10.0.0",
        "rimraf": "^6.0.1",
        "tsup": "^8.5.0",
        "typescript": "^5.9.2"
    },
    "engines": {
        "node": ">=18.0.0"
    }
}
